<div class="company-bond-request-page">
  <div *ngIf="!hideHeader" class="header">
    <img alt="back" src="assets/icons/entry-summary/left-arrow.svg" (click)="back()" />
    {{ "COMPANY.ANNUAL_CUSTOMS_BOND_QUESTIONNAIRE" | translate }}
  </div>
  <div class="company-bond-request-page-container" [ngClass]="{ 'without-header': hideHeader }">
    <div class="scrollable-wrapper">
      <div class="company-bond-request-page-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
